import { useEffect, useState } from 'react'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import { COLOR_PATH, addColor } from '../../api/colorApi'
import { useDispatch } from 'react-redux'
import { addColorAction } from '../../redux/feature/colorSlice'
import Button from '../../components/Button'
import Textarea from '../../components/Textarea'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import { useApiProgress } from '../../hooks/ApiProgress'

const ColorSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newColor, setNewColor] = useState({
        code: "",
        name: "",
        hexCode: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${COLOR_PATH}`, true)

    const onClickSubmit = () => {
        addColor(newColor)
            .then(res => {
                dispatch(addColorAction(res.data))
                closeTab()
                toast.success('Renk kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Renk</label>
                <Input
                    label='Renk Kodu'
                    name='code'
                    placeholder='Renk kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewColor, setErrors)}
                />
                <Input
                    label='Renk Adı'
                    name='name'
                    placeholder='Renk adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewColor, setErrors)}
                />
                <Input
                    label='Hex Kodu'
                    name='hexCode'
                    placeholder='Hex kodu girin'
                    error={errors.hexCode}
                    onChange={e => onChange(e, setNewColor, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewColor, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default ColorSubmitPage